import React, { useEffect, useState } from "react";
import { Capacitor } from "@capacitor/core";
import { App, AppState } from "@capacitor/app";
import { useAuth } from "@/contexts/AuthContext";
import { 
  syncNotificationPermissions, 
  getNotificationPermissionStatus
} from "@/integrations/onesignal";

/**
 * This component listens for app resume events and syncs
 * notification permissions with OneSignal whenever the app
 * is brought back to the foreground
 */
const NotificationPermissionSync: React.FC = () => {
  const { isAuthenticated, user } = useAuth();
  const [initialized, setInitialized] = useState(false);

  // Notification sync is now handled automatically in AuthContext after login
  // This component only handles app resume syncing
  useEffect(() => {
    if (Capacitor.isNativePlatform() && isAuthenticated) {
      setInitialized(true);
    }
  }, [isAuthenticated, user]);

  // Set up listeners for app resume events
  useEffect(() => {
    if (!Capacitor.isNativePlatform()) {
      
      return;
    }

    // Only sync if user is authenticated
    if (!isAuthenticated) {
      
      return;
    }

    

    // Variable to store the listener handle
    let resumeListenerHandle: { remove: () => void } | null = null;

    // App resume listener to check notification permissions
    App.addListener("resume", async () => {
      
      try {
        // Wait briefly to ensure the app is fully resumed
        await new Promise(resolve => setTimeout(resolve, 1000));
        
        // Perform the sync - our adapter in the onesignal module will handle plugin availability
        await syncNotificationPermissions();
        
      } catch (error) {
        
      }
    }).then(listener => {
      resumeListenerHandle = listener;
    });

    // Clean up listeners when component unmounts
    return () => {
      
      if (resumeListenerHandle) {
        resumeListenerHandle.remove();
      }
    };
  }, [isAuthenticated]);

  // This is a non-rendering component, so return null
  return null;
};

export default NotificationPermissionSync; 